import { CouponOrigin } from './couponOrigin';
import { FillinOrigin } from './fillinOrigin';

/**
 * Tipo de linha do relatório "Extrato de Operações" (Relatórios -> Financeiro).
 * Espelha `OperationStatementType` de pontuax-backend/src/models/operationStatementType.ts.
 */
export enum OperationStatementType {
  fillin = 'fillin',
  sale = 'sale',
  productRedemption = 'product_redemption',
  cashbackRedemption = 'cashback_redemption',
};

export namespace OperationStatementType {
  export const translateType = (type: OperationStatementType): string => {
    switch (type) {
      case OperationStatementType.fillin:
        return "Abastecimento";
      case OperationStatementType.sale:
        return "Venda no PDV";
      case OperationStatementType.productRedemption:
        return "Resgate de produto";
      case OperationStatementType.cashbackRedemption:
        return "Resgate de cashback";
      default: return "";
    };
  };

  export const operationStatementTypeChoices = Object.values(OperationStatementType).filter(x => typeof x === "string")
    .map(type => {
      return ({
        id: type,
        name: OperationStatementType.translateType(type as OperationStatementType)
      })
    });

  /** Situação do cupom do resgate, como o backend devolve em `coupon_status`. */
  export const translateCouponStatus = (status: string | null): string => {
    switch (status) {
      case 'used':
        return "Usado";
      case 'pending':
        return "Aguardando uso";
      case 'expired':
        return "Vencido";
      case 'refunded':
        return "Estornado";
      default: return "";
    };
  };

  /** Venda chega sempre pela API de vendas do PDV; abastecimento usa a origem dele; resgate, a do cupom. */
  export const translateOrigin = (type: OperationStatementType, origin: string | null): string => {
    if (type === OperationStatementType.sale) { return "PDV (integração)"; }
    return FillinOrigin.translateOrigin(origin as FillinOrigin) || CouponOrigin.translateOrigin(origin as CouponOrigin);
  };
};
